import * as React from 'react';

import * as styles from './MapRouteOnboardingContent.css';

export const MapRouteOnboardingContent: React.FC = () => {
  return <span className={styles['content']}>Стройте свои маршруты на карте</span>;
};
